<template>
  <div class="space-wrapper" :class="{'space-theme-color' : elementStyle != 'transparent'}" :style="spaceStyle">
  </div>
</template>
<script>
export default {
  props: {
    spacingHeight: {
      type: Number,
      default: 1
    },
    elementStyle: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
    spaceStyle() {
      let height = (window.innerHeight * this.spacingHeight) / 100
      return {
        'height': `${height}px`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Spacing.vue